import { AnalyticsEventEnvelope } from './event';

export class AnalyticsQueue<Event, Options = undefined> {
  private isEnabled = false;
  private entries: Array<AnalyticsEventEnvelope<Event, Options>> = [];

  public submit(
    event: Event,
    options: Options | undefined,
    dispatch: (event: Event, options?: Options) => void
  ): void {
    if (!this.isEnabled) {
      this.entries.push({ event, options });
      return;
    }

    dispatch(event, options);
  }

  public enable(dispatch: (event: Event, options?: Options) => void): void {
    this.isEnabled = true;
    this.entries.forEach(({ event, options }) => dispatch(event, options));
    this.entries = [];
  }
}
